import { TraceWriter } from '../../client/trace.js';
import type { ParsedArgs } from '../args.js';
import { numberFlag } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { downloadLogs } from './common.js';

export async function logsCommand(args: ParsedArgs): Promise<CommandResult> {
  const action = args.positionals[1] ?? 'trace';
  if (action === 'trace') {
    const last = numberFlag(args.flags, 'last') ?? 50;
    if (!Number.isInteger(last) || last <= 0) {
      throw new CliError('--last must be a positive integer', ExitCode.Usage);
    }
    return { data: new TraceWriter().readLast(last) };
  }
  if (action === 'download') {
    return downloadLogs(args, 'logs download requires --output <path>');
  }
  throw new CliError(`Unknown logs action "${action}"`, ExitCode.Usage);
}
